import React from "react";
import LogoImage from "./LogoImage";

const LogoImageLoading = ({ width = "104px", height = "104px" }) => {
  return <LogoImage src={"loading"} width={width} height={height} />;
};

export default LogoImageLoading;
